const generalData = {
  autoClickerName:
    "Safe Auto Clicker — Smart Mouse Click Automation for Any Website",
  // "Advanced To-Do List" was renamed to Plumnote - Notebook (same Chrome Web
  // Store item, same id) — the Home card now points there instead. The old
  // /to-do page and its data/images are left in the repo, just unlinked from
  // Home, in case they're still useful for reference.
  plumnoteName: "Plumnote - Notebook",
  error: "Error 404",
  btnBack: "Back",
};

export default generalData;
